import isEqual from "lodash/isEqual";

const firstValue = (value) => (Array.isArray(value) ? value[0] : value);

export const readQueryString = (value, fallback = "") => {
  const normalized = firstValue(value);
  return typeof normalized === "string" && normalized !== ""
    ? normalized
    : fallback;
};

export const readQueryList = (value, { integer = false } = {}) => {
  const values = (Array.isArray(value) ? value : [value])
    .flatMap((item) => String(item ?? "").split(","))
    .map((item) => item.trim())
    .filter(Boolean);

  if (!integer) return [...new Set(values)];
  return [
    ...new Set(
      values
        .map((item) => Number.parseInt(item, 10))
        .filter((item) => Number.isInteger(item) && item >= 0)
    ),
  ];
};

const queryValue = (value) => {
  if (Array.isArray(value)) return value.length ? value.join(",") : undefined;
  if (value === null || value === undefined || value === "") return undefined;
  return String(value);
};

export const replaceQueryParams = async (
  router,
  route,
  controlledKeys,
  values
) => {
  const query = { ...route.query };
  controlledKeys.forEach((key) => delete query[key]);
  Object.entries(values).forEach(([key, value]) => {
    const normalized = queryValue(value);
    if (normalized !== undefined) query[key] = normalized;
  });

  if (isEqual(query, route.query)) return;
  try {
    await router.replace({ path: route.path, query, hash: route.hash });
  } catch (error) {
    if (error?.name !== "NavigationDuplicated") throw error;
  }
};
